import classNames from 'classnames'
import { CgClose } from 'react-icons/cg'
import { twMerge } from 'tailwind-merge'

import { PopupProps } from './Popup.types.ts'

const Popup = ({
  isVisible,
  onClose,
  children,
  size = 'medium',
  className,
  classNameAuto
}: PopupProps) => {
  if (!isVisible) return null

  const sizeClasses = classNames({
    'max-w-screen-lg': size === 'auto',
    'lg:w-1/3 pb-25 ': size === 'small',
    'lg:w-2/3 pb-25 ': size === 'medium',
    'lg:w-11/12 pb-25 ': size === 'large'
  }, size === 'auto' ? classNameAuto : '')

  return (
    <div
      className={twMerge(
        'fixed inset-0 bg-gray-950/55 dark:bg-gray-850/35 overflow-auto flex z-999999',
        className
      )}
    >
      <div
        className={`bg-white dark:bg-gray-800 dark:text-white rounded-lg mx-auto my-auto my-6 shadow-lg relative max-w-screen-lg overflow-auto w-auto ${sizeClasses}`}
      >
        <button
          className="absolute top-2 right-2 text-gray-500 dark:text-gray-300 hover:text-gray-700 dark:hover:text-gray-100"
          onClick={onClose}
        >
          <CgClose size={28} className="cursor-pointer" />
        </button>
        {children}
      </div>
    </div>
  )
}

export default Popup
